<template>
  <div class="flash-sale-wrapper">
    <div class="flash-title">
      <div class="title-content">
        <img class="flash-icon" :src="$cvWebpFn('https://image.kilimall.com/kenya/PcImages/icon_flash.png')" alt="">
        <span class="title-text">Flash Sale</span>
        <span class="t-name">{{ statusText }}</span>
        <van-count-down :time="time_mm">
          <template #default="timeData">
            <div class="countdown">
              <span class="t-item">{{ format_time_fn(timeData.hours) }}</span>
              <span class="t-dot">:</span>
              <span class="t-item">{{ format_time_fn(timeData.minutes) }}</span>
              <span class="t-dot">:</span>
              <span class="t-item">{{ format_time_fn(timeData.seconds) }}</span>
            </div>
          </template>
        </van-count-down>
      </div>

      <div class="view-more" @click="$router.push('/flash-sales?source=homePage|flashSale|')">View more</div>
    </div>

    <div class="skus">
      <div class="sku-item" v-for="(item, idx) in previewSkus" :key="idx">
        <PCProductItemCard
          type="flash-sale"
          :product-data="item"
          :status="session.status"
          :isLazy="false"
          :flash-sale-session-label="sessionLabel"
          flash-sale-category-name="All"
          flash-sale-first-page="home"
          flash-sale-latest-page="home"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emits = defineEmits<{
  (e: 'no-data'): void
}>()

const { $tz } = useNuxtApp()

/** 获取秒杀文案， 未开始还是结束 */
const time_mm = ref<number>(0) // 倒计时毫秒
const statusText = ref<string>('Starting in')

const time_type_name = (session: any) => {
  const { status, startTime, endTime } = session
  if(!startTime || !endTime){
    return 0
  }
  
  if (status === 1) {
    // 已开始
    time_mm.value = new Date(endTime).getTime() - new Date().getTime()
    statusText.value = 'Ends in'
  } else {
    // 未开始
    time_mm.value = new Date(startTime).getTime() - new Date().getTime()
    statusText.value = 'Starting in'
  }
}
const format_time_fn = (time: number | string) => {
  if(Number(time) < 10) {
    return  '0' + time.toString()
  }
  return time
}

const previewSkus = ref<IFlashSaleSku[]>([])

const { skus, session } = useGlobalJsonData().value.flashsale.data
/** 与秒杀页一致：场次 label 用本地时区 hh:mm */
const sessionLabel = session?.startTime
  ? $tz.zeroToLocalZonetime(session.startTime, { format: 'hh:mm' })
  : ''
if(skus.length <= 0) {
  emits('no-data')
} else {
  time_type_name(session)
  previewSkus.value = (skus || []).slice(0, 5)
}
</script>

<style lang="scss" scoped>
.flash-sale-wrapper{
  min-height: 680px;
}
// @media (max-width: 1800px) {
//   .flash-sale-wrapper{
//     min-height: 560px;
//   }
// }
.flash-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #efefef;
  padding-bottom: 20px;
  height: 70px;
  .title-content{
    flex: 1;
    display: flex;
    align-items: center;
    .flash-icon{
      height: 50px;
      width: 50px;
      margin-right: 16px;
    }
    .title-text{
      font-size: 42px;
      font-weight: 600;
    }
    .t-name{
      font-size: 28px;
      color: #666;
      margin-left: 40px;
    }
    .countdown{
      margin-left: 40px;
      .t-dot{
        margin: 0 10px;
        font-weight: 600;
      }
      .t-item{
        background-color: var(--pc-default-color);
        padding: 6px 8px;
        color: #fff;
        border-radius: 4px;
        // margin-right: 18px;
        font-size: 28px;
        font-weight: 600;
      }
    }
  }
  .view-more{
    cursor: pointer;
    user-select: none;
    color: #666;
    transition: color .15s;
    &:hover{
      color: var(--pc-default-color);
    }
  }
}
.skus{
  display: flex;
  flex-wrap: nowrap;
  .sku-item{
    width: 20%;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>